import { IEventHandlerManager } from "./lib/IEventHandlerManager";
import { EventHandlerManager } from "./lib/EventHandlerManager";

export { IEventHandlerManager, EventHandlerManager };
